
import Vue from 'vue';
export default Vue.extend({
  props: ['total', 'current'],
  data() {
    return {
      adjacents: 3,
    };
  },
  methods: {
    range(min: number, max: number) {
      const range = [];
      let j = 0;
      for (let i = min; i <= max; i++) {
        range[j] = i;
        j++;
      }
      return range;
    },
    urlGenerator(page: number) {
      return '?page=' + page;
    },
  },
});
